module.exports = __webpack_public_path__ + "static/img/techs4.c512c26e.png";